// adapay_merchant 開戶設定

import fetch from '@/utils/fetch'

// 商戶開戶步驟
export const getStep = () => {
  return fetch({
    url: '/adapay/open_account/step',
    method: 'get'
  })
}

// 商戶結算銀行
export const getBank = (params) => {
  return fetch({
    url: '/adapay/bank/list',
    method: 'get',
    params
  })
}

// 獲取地區（4位）
export const getPro = (id) => {
  return fetch({
    url: '/adapay/regions/list',
    method: 'get',
    params: id
  })
}

// 獲取地區（6位）
export const getCity = (id) => {
  return fetch({
    url: `/adapay/regions_third/list/`,
    method: 'get',
    params: id
  })
}

// 開戶企業
export const accountCreate = (params) => {
  return fetch({
    url: '/adapay/merchant_entry/create',
    method: 'post',
    params
  })
}
// 開戶個人
export const accountCreatePerson = (params) => {
  return fetch({
    url: '/adapay/member/create',
    method: 'post',
    params
  })
}
// 查詢企業物件
export const accountQueryCorp = () => {
  return fetch({
    url: '/adapay/member/get',
    method: 'get'
  })
}
// 更新開戶企業
export const accountUpdate = (params) => {
  return fetch({
    url: '/adapay/corp_member/update',
    method: 'post',
    params
  })
}
export const accountUpdateCorp = (params) => {
  return fetch({
    url: 'adapay/corp_member/modify',
    method: 'post',
    params
  })
}
// 更新開戶個人
export const accountUpdatePerson = (params) => {
  return fetch({
    url: '/adapay/member/update',
    method: 'post',
    params
  })
}

// 店鋪、經銷商開戶更新
export const accountPersonUpdate = (params)=>{
  return fetch({
    url:'adapay/member/modify',
    method:'post',
    params
  })
}

// 支付渠道基礎配置
export const pay_options = () => {
  return fetch({
    url: 'adapay/other/cat',
    method: 'get'
  })
}

// 獲取經營類目
export const getCategoryList = (params) => {
  return fetch({
    url: '/adapay/wx_business_cat/list',
    method: 'get',
    params
  })
}

// 獲取商戶種類
export const getMerTypeOption = (params) => {
  return fetch({
    url: '/adapay/other/cat',
    method: 'get',
    params
  })
}

// 提交支付渠道入駐
export const submitPay = (params) => {
  return fetch({
    url: '/adapay/merchant_resident/create',
    method: 'post',
    params
  })
}

// 上傳圖片
export const uploadPic = (params) => {
  return fetch({
    url: '/adapay/license/upload',
    method: 'post',
    params
  })
}

// 提交photo稽核
export const submitPhoto = (params) => {
  return fetch({
    url: '/adapay/license_submit/create',
    method: 'post',
    params
  })
}

// 分賬
export const subAccount = (params) => {
  return fetch({
    url: '/adapay/trade/list',
    method: 'get',
    params
  })
}
// 匯出分賬檔案
export const exportFileList = (params) => {
  return fetch({
    url: '/adapay/trade/exportdata',
    method: 'get',
    params
  })
}

// 檢視分賬詳情
export const subAccountDetail = (id) => {
  return fetch({
    url: `/adapay/trade/info/${id}`,
    method: 'get'
  })
}

// 獲取提款記錄
export const withdrawList = (params) => {
  return fetch({
    url: '/adapay/drawcash/getList',
    method: 'get',
    params
  })
}

// 申請提款
export const applyForWithdrawal = (params) => {
  return fetch({
    url: '/adapay/withdraw',
    method: 'post',
    params
  })
}

// adapay支付配置
export const getAdapayPaySettingKey = () => {
  return fetch({
    url: '/adapay/generate/key',
    method: 'get'
  })
}
export const getAdapayPaySetting = () => {
  return fetch({
    url: '/trade/payment/setting',
    method: 'get'
  })
}
export const postAdapayPaySetting = (params) => {
  return fetch({
    url: '/trade/payment/setting',
    method: 'post',
    params
  })
}

// 設定子商戶每日提款額度
export const setChildWithdraw = (params) => {
  return fetch({
    url: '/adapay/sub_approve/draw_limit',
    method: 'post',
    params
  })
}

// 獲取子商戶每日提款額度
export const getChildWithdraw = () => {
  return fetch({
    url: '/adapay/sub_approve/draw_limit',
    method: 'get'
  })
}

/* 匯付二期 */

// 獲取提款設定
export const withDrawSetting = () => {
  return fetch({
    url: '/adapay/sub_approve/draw_cash_config',
    method: 'get'
  })
}

// 選擇商戶
export const seleteBusiness = (params) => {
  return fetch({
    url: '/adapay/member/list',
    method: 'get',
    params
  })
}

// 儲存提款設定
export const saveDrawSetting =(params)=>{
  return fetch({
    url:'/adapay/sub_approve/draw_cash_config',
    method:'post',
    params
  })
}

